<template>
  <button @click="onClickTidLogin">
    <slot>
      <sns-logo-circle sns-name="tid" :width="44" :height="44" />
    </slot>
    <span class="a11y-hidden">T아이디로 로그인</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import utils from '@/common/util/utils'

  const emit = defineEmits(['success', 'fail'])
  const route = useRoute()

  const onClickTidLogin = () => {
    const loginUrl = utils.login.getMemberSnsLoginUrl({
      type: 'tid',
      callback: location.href,
    })
    location.href = loginUrl
  }

  onMounted(() => {
    const { type, token } = route.query
    if (type === 'tid') {
      if (token) {
        emit('success', { token })
      } else {
        emit('fail', { message: 'Failed to get token' })
      }
    }
  })
</script>
